import script from "./goRinSyo0057.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0057.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0057.vue?vue&type=style&index=0&id=7df5ff9a&lang=scss"

const __exports__ = script;

export default __exports__